import { PermissionManager } from "@utils/permissionManager";
import { useTranslation } from "react-i18next";
import { ActionConfirmModal } from "shared/modals/index";
import { useModal } from "use-modal-hook";
import { archiveOpportunity, deleteOpportunity, deleteOpportunityPermanently, restoreOpportunity } from "../reducer/OpportunityActions";

export default function BaseActions({ opportunity, handleRedirect = null, onClose }) {
	const { t } = useTranslation();

	const id = opportunity?.id;

	const [actionConfirmModal] = useModal(ActionConfirmModal);

	const handleArchive = () => {
		actionConfirmModal({
			bodyContent: "ARCHIVE_GENERIC",
			Action: () => archiveOpportunity({ id, onSuccess: onClose ? onClose : handleRedirect }),
			actionBtnText: "ARCHIVE",
		});
	};

	const handleDelete = () => {
		actionConfirmModal({
			bodyContent: "DELETE_GENERIC",
			Action: () => deleteOpportunity({ id, onSuccess: onClose ? onClose : handleRedirect }),
			actionBtnText: "ASPX_13",
		});
	};

	const handleDeletePermanent = () => {
		actionConfirmModal({
			bodyContent: "ASPX_204",
			Action: () => deleteOpportunityPermanently({ id }),
			actionBtnText: "ASPX_13",
		});
	};

    const { archiveAllowed, deleteAllowed, restoreAllowed, deletePermanentAllowed } = PermissionManager({});

	const createActions = () => {
		let actions = [];
		if ((archiveAllowed || deleteAllowed) && actions?.length > 0) actions.push({ id: "divider", divider: true });
		if (archiveAllowed) {
			actions.push({
				id: "archive",
				handleClick: handleArchive,
				icon: "ARCHIVE",
				text: t("ARCHIVE"),
			});
		}
		if (deleteAllowed) {
			actions.push({
				id: "delete",
				handleClick: handleDelete,
				icon: "DELETE",
				text: t("CS_45"),
			});
		}
		if (restoreAllowed) actions.push({ id: "restore", handleClick: () => restoreOpportunity({ id }), icon: "RESTORE", text: t("JS_96") });
		if (deletePermanentAllowed) actions.push({ id: "deletePermanent", handleClick: handleDeletePermanent, itemStyle: "warning-delete", icon: "DELETE", text: t("JS_97") });
		if (opportunity?.isSample) {
			actions = actions.filter((action) => action.id === "copy");
		}
		return actions;
	};

	return createActions();
}
